module.exports = __webpack_public_path__ + "media/images/slide3-558bc462e3ab3858a0e81e7520a74149.jpg";